import { Components, createTheme, Theme } from "@mui/material/styles";

const baseTheme = createTheme();

const MuiFormControlLabel: Components<Theme>["MuiFormControlLabel"] = {
  styleOverrides: {
    root: {
      "& .MuiFormControlLabel-label": {
        fontWeight: "bold",
        color: baseTheme.palette.text.primary,
      },
    },
  },
};

export default MuiFormControlLabel;
